<template>
  <div>
    <DiagnosesFilter
      v-if="$can('filter', 'allergies')"
      :loading="loading"
      @searchFilter="searchFilter"
      @filterPage="filterPage"
    />
    <b-card>
      <TitleTable titleTable="Diagnoses" iconTable="far fa-file-alt" />
      <div class="m-1">
        <DiagnosesEdit
          v-if="isEditDiagnosesSidebarActive"
          :is-edit-diagnoses-sidebar-active.sync="isEditDiagnosesSidebarActive"
          :itemEdit="itemEdit"
          @editDiagnosesItem="editDiagnosesItem"
        />
        <DiagnosesAdd
          :is-add-new-diagnoses-sidebar-active.sync="isAddNewDiagnosesSidebarActive"
          @createDiagnoses="createDiagnoses"
        />
        <!-- Table Top -->
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <treeselect
              v-model="perPage"
              :options="perPageOptions"
              :clearable="true"
              class="w-25"
            />
          </b-col>
          <!-- {{ $t("Search") }} -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <GoBack class="mr-2" />
              <b-button
                v-if="$can('store', 'allergies')"
                variant="primary"
                @click="isAddNewDiagnosesSidebarActive = true"
                :disabled="loading"
              >
                <span v-if="!loading" class="text-nowrap"
                  >{{ $t("Add") }} Diagnoses</span
                >
                <span v-else>
                  <SpinnerLoading />
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        :items="items"
        :fields="fields"
        hover
        bordered
        responsive
        primary-key="id"
        class="position-relative"
        show-empty
        empty-text="No matching records found"
      >
        <template #cell(status)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{
              data.item.status ? $t("Active") : $t("Inactive")
            }}</span>
          </div>
        </template>
        <template #cell(actions)="data">
          <b-button
            v-if="$can('update', 'allergies')"
            variant="outline-primary"
            class="btn-icon btn-circle border-0"
            v-b-tooltip.hover.top="'Edit'"
            @click="editDiagnoses(data.item)"
          >
            <i class="fas fa-pen icon-nm"></i>
          </b-button>

          <b-button
            v-if="$can('destroy', 'allergies')"
            variant="outline-danger"
            class="btn-icon btn-circle border-0"
            v-b-tooltip.hover.top="'Delete'"
            @click="deleteDiagnoses(data.item)"
          >
            <i class="fas fa-trash-alt icon-nm"></i>
          </b-button>
        </template>
      </b-table>
      <PaginationTable
        :dataMeta="dataMeta"
        :totalUsers="totalUsers"
        :perPage="perPage"
        :currentPage="currentPage"
        @page-changed="pageChanged"
      />
    </b-card>
    <ToastNotification ref="toast" />
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BBadge,
  BAvatar,
  BButton,
  VBTooltip,
} from "bootstrap-vue";
import axiosAC from "@/core/services/api/admin/consults/diagnoses";

import ToastNotification from "@/components/ToastNotification";
import SpinnerLoading from "@/components/SpinnerLoading";
import PaginationTable from "@/components/PaginationTable";
import TitleTable from "@/components/TitleTable.vue";
import GoBack from "@/components/ButtonBack.vue";
import Swal from "sweetalert2";

import DiagnosesEdit from "./DiagnosesEdit.vue";
import DiagnosesAdd from "./DiagnosesAdd.vue";
import DiagnosesFilter from "./DiagnosesFilter.vue";
import { ref } from "@vue/composition-api";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BBadge,
    BAvatar,
    BButton,
    DiagnosesEdit,
    DiagnosesAdd,
    DiagnosesFilter,
    ToastNotification,
    SpinnerLoading,
    PaginationTable,
    TitleTable,
    GoBack,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      fields: [
        "id",
        { key: "name", label: "Name", sortable: true },
        { key: "status", label: "Status" },
        { key: "actions", label: "Actions" },
      ],
      items: null,
      loading: false,
      isEditDiagnosesSidebarActive: false,
      isAddNewDiagnosesSidebarActive: false,
      itemEdit: null,
      dataMeta: { from: 1, to: 1, of: 1 },
      totalUsers: 0,
      perPage: 10,
      currentPage: {
        page: 1,
      },
      perPageOptions: [10, 25, 50, 100].map((i) => ({
        id: i,
        label: `Show ${i} Entries`,
      })),
      filtro: false,
      diagnosesFilter: null,
    };
  },
  mounted() {
    this.getDiagnoses();
  },
  watch: {
    perPage(newVal) {
      if (!this.filtro) {
        this.getDiagnoses();
      } else {
        this.searchFilter(this.diagnosesFilter);
      }
    },
  },
  methods: {
    getDiagnoses() {
      axiosAC
        .diagnosesList(this.perPage)
        .then(({ data, current_page, total, per_page, ...res }) => {
          this.items = data;
          this.totalUsers = total;
          this.dataMeta.of = total;
          this.dataMeta.from = res.from;
          this.dataMeta.to = res.to;
          this.currentPage.page = current_page;
        });
    },
    editDiagnoses(item) {
      this.isEditDiagnosesSidebarActive = true;
      this.itemEdit = ref(JSON.parse(JSON.stringify(item)));
    },
    editDiagnosesItem(value) {
      if (value) {
        this.$refs.toast.success("Type Diagnoses updated successfully");
      } else {
        this.$refs.toast.error("Error updating type diagnoses");
      }
      this.isEditDiagnosesSidebarActive = false;
      this.pageChanged(this.currentPage.page);
    },
    createDiagnoses({ status }) {
      if (status) {
        this.$refs.toast.success("Diagnoses type added successfully");
      } else {
        this.$refs.toast.danger("Diagnoses type not added");
      }
      this.isAddNewDiagnosesSidebarActive = false;
      this.pageChanged(this.currentPage.page);
    },
    deleteDiagnoses(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this",
        icon: "error",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axiosAC.diagnosesDelete(item.id).then((response) => {
            this.$refs.toast.success(
              "Diagnoses type has been deleted successfully"
            );
            this.pageChanged(this.currentPage.page);
          });
        }
      });
    },
    pageChanged(page) {
      if (!this.filtro) {
        axiosAC
          .diagnosesPagination(this.perPage, page)
          .then(({ data, total, current_page, ...res }) => {
            this.items = data;
            this.totalUsers = total;
            this.dataMeta.of = total;
            this.dataMeta.from = res.from;
            this.dataMeta.to = res.to;
            this.currentPage.page = current_page;
          });
      } else {
        axiosAC
          .diagnosesFilterPagination(this.perPage, page, this.diagnosesFilter)
          .then(({ data, total, current_page, ...res }) => {
            this.items = data;
            this.totalUsers = total;
            this.dataMeta.of = total;
            this.dataMeta.from = res.from;
            this.dataMeta.to = res.to;
            this.currentPage.page = current_page;
          });
      }
    },
    searchFilter(value) {
      if (this.filtro) {
        this.loading = true;
        this.diagnosesFilter = value;
        axiosAC
          .diagnosesFilter(this.perPage, value)
          .then(({ data, total, current_page, ...res }) => {
            this.loading = false;
            this.items = data;
            this.totalUsers = total;
            this.dataMeta.of = total;
            this.dataMeta.from = res.from;
            this.dataMeta.to = res.to;
            this.currentPage.page = current_page;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.getDiagnoses();
      }
    },
    filterPage(value) {
      this.filtro = value;
    },
  },
};
</script>

<style></style>
